import { getCategory } from './categories';

/**
 * Calculate glycemic load based on GI, carbs, and portion
 * @param {number} gi - Glycemic Index
 * @param {number} carbs - Carbohydrates per 100g
 * @param {number} portion - Portion size in grams (default: 100)
 * @returns {number} Glycemic Load
 */
export const calculateGL = (gi, carbs, portion = 100) => {
  return Math.round((gi * carbs * portion) / (100 * 100));
};

/**
 * Calculate total meal glycemic load
 * @param {Array} selectedFoods - Array of selected foods with quantities
 * @returns {number} Total meal GL
 */
export const calculateMealGL = (selectedFoods) => {
  return selectedFoods.reduce((total, food) => {
    return total + calculateGL(food.gi, food.carbs, food.quantity);
  }, 0);
};

/**
 * Estimate GI from nutrition facts (simplified estimation)
 * @param {number} sugar - Sugar content
 * @param {number} fiber - Fiber content
 * @param {number} protein - Protein content
 * @param {number} fat - Fat content
 * @returns {number} Estimated GI
 */
export const calculateGIFromNutrition = (sugar, fiber, protein, fat) => {
  let estimatedGI = 55; // Base moderate GI
  
  // Sugar content influence
  if (sugar > 20) estimatedGI += 15;
  else if (sugar > 10) estimatedGI += 10;
  else if (sugar > 5) estimatedGI += 5;
  
  // Fiber content influence
  if (fiber > 10) estimatedGI -= 15;
  else if (fiber > 5) estimatedGI -= 10;
  else if (fiber > 2) estimatedGI -= 5;
  
  // Protein and fat influence
  if (protein > 15) estimatedGI -= 10;
  if (fat > 10) estimatedGI -= 10;
  
  return Math.max(15, Math.min(100, estimatedGI));
};

// Re-export getCategory for convenience
export { getCategory };